import type { GuideModule } from '../types';
import { BILLING_MODULE } from './billing';
import { CALENDAR_MODULE } from './calendar';
import { CATALOG_MODULE } from './catalog';
import { CONFIGURACION_MODULE } from './configuracion';
import { CONTRACTS_MODULE } from './contracts';
import { CUSTOMERS_MODULE } from './customers';
import { DAY_FLOW_MODULE } from './day-flow';
import { DELIVERY_NOTES_MODULE } from './delivery-notes';
import { FISCAL_CONFIG_MODULE } from './fiscal-config';
import { NOTIFICATIONS_MODULE } from './notifications';
import { ONBOARDING_MODULE } from './onboarding';
import { ORDERS_MODULE } from './orders';
import { PAYMENTS_MODULE } from './payments';
import { PRODUCTION_MODULE } from './production';
import { ROLES_MODULE } from './roles';
import { SYSTEM_PARAMETERS_MODULE } from './system-parameters';
import { USERS_MODULE } from './users';

export const GUIDE_MODULES: GuideModule[] = [
  ONBOARDING_MODULE,
  DAY_FLOW_MODULE,
  USERS_MODULE,
  ROLES_MODULE,
  CUSTOMERS_MODULE,
  CONTRACTS_MODULE,
  CATALOG_MODULE,
  CALENDAR_MODULE,
  ORDERS_MODULE,
  PRODUCTION_MODULE,
  DELIVERY_NOTES_MODULE,
  BILLING_MODULE,
  PAYMENTS_MODULE,
  FISCAL_CONFIG_MODULE,
  CONFIGURACION_MODULE,
  SYSTEM_PARAMETERS_MODULE,
  NOTIFICATIONS_MODULE,
];
